/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Utils\company.utils.ts
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Thursday June 20th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday June 20th 2024 3:14:21 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

export const formatSiren = (value: string) => {
    const cleanedValue = value.replace(/\s+/g, '');
    const part1 = cleanedValue.slice(0, 9).replace(/(\d{3})(?=\d)/g, '$1 ').trim();
    // const part2 = cleanedValue.slice(9);
    return `${part1}`.trim();
    // return `${part1} ${part2}`.trim();
};

